export const handleResponse = res => {
	if (!res.ok) {
		throw new Error(`HTTP error! status: ${res.status}, text: ${res.statusText}`);
	}

	return res.json();
};
